// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"161":"b2617131","350":"86995e61","933":"1a2446cf"}[chunkId] + ".chunk.css";
};